import {CancelToken} from '../../../libs/shared/core/src/helpers/utilities/asyncCancelHelpers';
import {
  ApiChatAblyAuthorizationResponse,
  ChatAblyAuthorizationResponse,
} from '../../../libs/shared/core/src/models/api/chatAblyAuthorizationResponseModel';
import {postApiAsync} from '../../../libs/shared/core/src/services/http/http';
import {HttpResponseError} from '../../../libs/shared/core/src/services/http/httpError';
import {chatPushLogger} from './chatPushLogger';

/*
 * API method.
 */

export async function fetchChatAblyToken(
  nextConversations: Array<number>,
  cancelToken: CancelToken,
  companyUrl: string,
): Promise<ChatAblyAuthorizationResponse | null> {
  try {
    return postApiAsync(
      ApiChatAblyAuthorizationResponse,
      `${companyUrl}/ably/auth_chat`,
      {
        conversation_ids: nextConversations,
      },
      {cancelToken},
    );
  } catch (error) {
    if (error instanceof HttpResponseError && error.status === 404) {
      return null;
    }

    if (error instanceof HttpResponseError) {
      chatPushLogger.warn('Failed to authorize Ably chat', {
        conversationIds: nextConversations,
        status: error.status,
        body: JSON.stringify(error.body),
      });
    }

    throw error;
  }
}
